import * as styles from './NotificationWrapper.css';

export const TRANSITION_DELAY = 400;

export const TRANSITION_STYLES = {
  enter: styles['notification-enter'],
  enterActive: styles['notification-enter-active'],
  exit: styles['notification-exit'],
  exitActive: styles['notification-exit-active'],
};
